import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Lock } from "lucide-react";
import { COMPANY } from "@/lib/pricing";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(password);
      navigate("/");
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1C1917] flex items-center justify-center p-4">
      <div className="w-full max-w-md kg-rise">
        <div className="flex flex-col items-center gap-3 mb-8">
          <img
            src="/kg-logo.png"
            alt="K&G Mowers + Tractors"
            className="h-20 w-auto"
            data-testid="login-logo"
          />
          <p className="text-sm text-stone-400">Route &amp; Delivery Pricing</p>
        </div>

        <form
          onSubmit={submit}
          className="bg-white rounded-xl p-8 space-y-5 shadow-2xl"
          data-testid="login-form"
        >
          <div>
            <h2 className="text-lg font-bold text-[#1C1917]">Staff Access</h2>
            <p className="text-sm text-[#57534E]">Enter the shared staff password to continue.</p>
          </div>
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#57534E]" />
            <Input
              type="password"
              placeholder="Staff password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="pl-9 focus-visible:ring-2 focus-visible:ring-[#F97316]/30 focus-visible:border-[#F97316]"
              data-testid="login-password-input"
              autoFocus
            />
          </div>
          {error && (
            <p className="text-sm text-red-600" data-testid="login-error">
              {error}
            </p>
          )}
          <Button
            type="submit"
            disabled={loading || !password}
            className="w-full bg-[#F97316] hover:bg-[#EA580C] text-white font-bold"
            data-testid="login-submit-button"
          >
            {loading ? "Checking…" : "Enter"}
          </Button>
        </form>
        <p className="text-center text-xs text-stone-500 mt-6">
          {COMPANY.address} &middot; {COMPANY.phone}
        </p>
      </div>
    </div>
  );
}
